import type { WalletSelectionSnapshot } from "../wallet/wallet-connection";
import forestArtwork from "../assets/greenwood-forest-terminal-tree.jpg";
import { WalletIcon, ChevronDownIcon } from "./Icons";
import { Overlay } from "./overlays/Overlay";
import "../styles/wallet-modal.css";

export function ConnectWalletModal({ selection, demo, authenticate = false, onClose, onConnect }: {
  selection: WalletSelectionSnapshot; demo: boolean; authenticate?: boolean; onClose(): void; onConnect(id: string): void;
}) {
  const busy = selection.pendingId !== null;
  return <Overlay open={selection.isOpen} title="Connect wallet" className="wallet-connect-modal" onClose={onClose}>
    <div className="wallet-forest-art" aria-hidden="true">
      <img src={forestArtwork} alt="" />
      <div className="wallet-forest-caption"><span className="status-led" /> A quiet place to grow.</div>
    </div>
    <div className="wallet-chooser-body">
      <div className="settings-heading"><div><strong>Choose your wallet</strong>
        <span>{demo ? "Explore with a demo wallet. No real connection is made." : "Your wallet is your way into the forest."}</span>
      </div></div>
      {selection.isDetecting && selection.wallets.length === 0 ? <p className="wallet-chooser-status" role="status">Looking for wallets…</p> : null}
      {!selection.isDetecting && selection.wallets.length === 0 ? <div className="wallet-chooser-empty" role="status">
        <WalletIcon /><strong>No wallets found</strong>
        <p>Install or unlock a browser wallet, then reopen this window.</p>
      </div> : null}
      <ul className="wallet-choices" aria-label="Available wallets" aria-busy={busy}>
        {selection.wallets.map(wallet => <li key={wallet.id}><button type="button" disabled={busy}
          className="wallet-choice" onClick={() => onConnect(wallet.id)}>
          <span className="wallet-choice-icon" aria-hidden="true">{wallet.icon ? <img src={wallet.icon} alt="" width={28} height={28} /> : <WalletIcon />}</span>
          <span className="wallet-choice-label"><strong>{wallet.name}</strong><span>{selection.pendingId === wallet.id ? "Waiting for approval…" :
            demo ? "Visual preview only" : wallet.kind === "remote" ? "Connect with your phone" : "Browser extension"}</span></span>
          <ChevronDownIcon className="wallet-choice-arrow" />
        </button></li>)}
      </ul>
      {busy ? <p className="wallet-chooser-status" role="status">Approve the connection in your wallet. You can close this window while you wait.</p> : null}
      {selection.error ? <p className="wallet-chooser-error">{selection.error}</p> : null}
      <p className="wallet-chooser-footnote">{demo ? "Demo mode · no signatures or transactions" : authenticate
        ? "After connecting, your wallet may request a Sign in signature for this session. This does not authorize a transaction."
        : "Connect your wallet to continue. This does not request a Sign in signature or a transaction."}</p>
    </div>
  </Overlay>;
}
